const doc = [({"da":({"js":({"proposal_types":({"presenter_card":({"deadline_for_proposals_at":"Deadline for forslag d. %{date_time}", "count_of_propoals":"%{count} forslag"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;